// extracted by mini-css-extract-plugin
export var formContainer = "_ca-0";
export var message = "_ca-1";